var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressBarAerial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62926 0.73104C8.62394 0.730985 8.61862 0.730957 8.61328 0.730957H8.64492C8.6397 0.730957 8.63448 0.730985 8.62926 0.73104Z",
    fill: "#030303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62926 0.73104C7.11922 0.747055 6.11367 3.07661 6.11367 4.30635V5.63525L1.05117 8.79932C0.766406 8.92588 0.544922 9.30557 0.544922 9.65361V11.7103C0.544922 12.0267 0.703125 12.3431 0.95625 12.5329C1.20938 12.7228 1.55742 12.786 1.84219 12.6911L6.11367 11.3306V12.1216L4.5 13.3556C4.24688 13.5454 4.08867 13.8302 4.08867 14.1466V15.9501C4.08867 16.2349 4.24688 16.5513 4.5 16.7411C4.75313 16.931 5.06953 16.9942 5.3543 16.931L8.64492 15.9501L11.9355 16.8993C12.2203 16.9942 12.5367 16.931 12.7898 16.7411C12.2203 16.3298 11.7773 15.7919 11.3977 15.1591L8.61328 14.3681L5.57578 15.254V14.3997L7.60078 12.881V9.27393L2.03203 11.0142V9.93838L7.60078 6.45791V4.30635C7.60078 3.48369 8.29688 2.34463 8.61328 2.28135C8.96133 2.31299 9.62578 3.45205 9.62578 4.30635V6.45791L12.5051 8.22979C12.9164 7.88174 13.391 7.56533 13.8973 7.31221L11.1762 5.60361V4.27471C11.1762 3.0765 10.1706 0.747055 8.62926 0.73104Z",
    fill: "#030303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 13.7669C10.7016 13.3239 10.6383 12.8493 10.6383 12.3747C10.6383 11.4255 10.8914 10.5712 11.3027 9.78018L9.62578 9.27393V12.881L10.8281 13.7669Z",
    fill: "#030303"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1512 8.2042C15.993 8.14092 15.7715 8.14092 15.6133 8.2042L11.8164 9.72295C11.5 9.84951 11.3418 10.1343 11.3418 10.419C11.3418 12.444 12.1328 15.7663 15.5816 17.2218C15.7715 17.2851 15.993 17.2851 16.1828 17.2218C19.6316 15.7663 20.4543 12.444 20.4543 10.419C20.4543 10.1343 20.2645 9.84951 19.948 9.72295L16.1512 8.2042ZM15.898 15.6714V9.72295L18.9039 10.9253C18.7773 12.539 18.0496 14.6272 15.898 15.6714Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarAerial);
export default __webpack_public_path__ + "static/media/ProgressBarAerial.0eb57ec087031b032b99e26cbd15e0d0.svg";
export { ForwardRef as ReactComponent };